import * as React from "react";

import ImportFile from "../../../components/Forms/IMD/Import/ImportFile/FlowForm";

export default () => {
  return <ImportFile />;
};
